import React from 'react';
import Cookies from 'universal-cookie';
import { TbNumbers } from 'react-icons/tb'; 
import { MdAccessTimeFilled, MdOutlineGrade } from 'react-icons/md';
import { VscTypeHierarchySub } from 'react-icons/vsc';
import translateString from "../../utils/Locales";

const cookies = new Cookies();
const qs = require('querystring');
let t = translateString;


export default class InfoTest extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: undefined,
        };
        this.dbPath = cookies.get('db_path', { path: '/' });
    } 

    componentDidMount() {
        const parsed = qs.parse(window.location.hash);
        let id = parsed['#/app/infoTest?id']
        if (!id) {
            window.location.href = '/' + this.dbPath + "/#/app/dashboard";
            return
        }
        this.setState({id})

    }

    render() {

        return(
            <div className='dashboard-container'>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 30 }}>
                    <section style={{ width: '100%' }}>
                        <h1>{this.state.nome_test}</h1>
                        <p>{t('start_info0')}</p>
                    </section>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 30 }}>
                    <section style={{ width: '100%' }}>
                        <div style={{display:'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'}}>
                            <TbNumbers size={25} style={{ marginTop: -15, marginRight:20 }} />
                            <p style={{ maxWidth: '80%' }}>{t('start_info0')}</p>
                        </div>
                        <div style={{display:'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'}}>
                            <MdAccessTimeFilled size={25} style={{ marginTop: -15, marginRight:20 }} />
                            <p style={{ maxWidth: '80%' }}>{t('start_info2')}</p>
                        </div>
                        <div style={{display:'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'}}>
                            <VscTypeHierarchySub size={25} style={{ marginTop: -15, marginRight:20 }} />
                            <p style={{ maxWidth: '80%' }}>{t('start_info3')}</p>
                        </div>
                        <p style={{ marginLeft: 80 }}><b>{t('start_info4')}</b>{t('start_info5')}</p>
                        <p style={{ marginLeft: 80 }}><b>{t('start_info6')}</b>{t('start_info7')}</p>
                        <p style={{ marginLeft: 80 }}><b>{t('start_info8')}</b>{t('start_info9')}</p>
                        <p style={{ marginLeft: 80 }}><b>{t('start_info10')}</b>{t('start_info11')}</p>
                        <p style={{ marginLeft: 80 }}><b>{t('start_info12')}</b>{t('start_info13')}</p>
                        <p style={{ marginLeft: 80 }}><b>Cloze</b>{t('start_info14')}</p>
                        <p style={{ marginLeft: 80 }}><b>{t('start_info15')}</b>{t('start_info16')}</p>
                        <p style={{ marginLeft: 80 }}><b>{t('start_info17')}</b>{t('start_info18')}</p>
                        <div style={{display:'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginTop: 30 }} >
                            <MdOutlineGrade size={25} style={{ marginTop: -15, marginRight:20 }} />
                            <p style={{ maxWidth: '80%' }}>{t('start_info19')}</p>
                        </div>
                    </section>
                    <section className='info-img' style={{ width: '100%' }}>
                        <img src={ require('../../images/info_test.png') } style={{ width: '80%', height: 'auto', opacity: 0.7 }} alt="Avviso" />
                    </section>
                </div>
                <div style={{ width: '50%', marginLeft: '25%' }}>
                    <button style={{ marginTop: 30, backgroundColor: '#1877F2', color: 'white', padding: 10, border: 0, width: '100%', borderRadius: '5px', cursor:'pointer' }} onClick={ this.state.isLoading ? () => {} : async () => {

                        this.setState({ isLoading: true });
                        
                        let username = cookies.get('username');
                        let token = cookies.get('token');
                        // let res = await iniziaTest(username, token, this.state.id_test);
                        // if (!res || res.result === 'KO') {
                        //     alert('Impossibile iniziare il test al momento. Riprova più tardi.');
                        //     return;
                        // }

                        // cookies.set('idTest', res.id);

                        window.location.href = '/' + this.dbPath + '/#/app/test?id=' + this.state.id;
                    }} >{t('start_test')}</button>
                </div>
            </div>
        );
    }
}